const applicationSecondReviewerKPIs = [
    {
        "uuid": "1",
        "appType": "初次申請",
        "secondReviewer": "人員A",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "2",
        "appType": "定追",
        "secondReviewer": "人員A",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "3",
        "appType": "展延",
        "secondReviewer": "人員A",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "4",
        "appType": "小計",
        "secondReviewer": "",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "5",
        "appType": "定追",
        "secondReviewer": "人員B",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "6",
        "appType": "異動",
        "secondReviewer": "人員B",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "7",
        "appType": "外標示",
        "secondReviewer": "人員B",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "8",
        "appType": "小計",
        "secondReviewer": "",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
    {
        "uuid": "9",
        "appType": "總計",
        "secondReviewer": "",
        "appQuantity": "",
        "totalSentTimes": "",
        "timeComplianceRate": "",
    },
]

export default applicationSecondReviewerKPIs;